'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('redux-form/immutable');

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _constants = require('../../constants');

var _FormComponent = require('./FormComponent');

var _FormComponent2 = _interopRequireDefault(_FormComponent);

var _selectors = require('../../selectors');

var _actions = require('../../actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getApplePayLimits = function getApplePayLimits(activeCard) {
  return activeCard && activeCard.info && activeCard.info.validation || { minDepAmt: '0.00', maxDepAmt: '0.00' };
};

var mapStateToProps = function mapStateToProps(state, props) {
  var isApplePayAvailable = (0, _selectors.getIsApplePayAvailable)(state);
  var activeCard = (0, _selectors.activeCardSelector)(state);
  var minDeposit = isApplePayAvailable ? getApplePayLimits(activeCard).minDepAmt : activeCard.get('pmtMinAmt');
  var maxDeposit = isApplePayAvailable ? getApplePayLimits(activeCard).maxDepAmt : activeCard.get('pmtMaxAmt');

  return {
    hasPlayerSetAmount: (0, _selectors.playerAmountSelectionSelector)(state),
    layout: (0, _selectors.layoutSelector)(state),
    initData: (0, _selectors.initDataSelector)(state, props),
    activeDeposit: (0, _selectors.activeDepositDataSelector)(state),
    hasVisibleErrors: (0, _selectors.hasVisibleErrors)(state),
    countryCode: (0, _selectors.countryCodeSelector)(state, props),
    isDefaultCardChanged: (0, _selectors.isDefaultCardChangedSelector)(state, props),
    isApplePayAvailable: isApplePayAvailable,
    qdConfig: (0, _selectors.configSelector)(state),
    maxDeposit: maxDeposit,
    minDeposit: minDeposit
  };
};

var mapDispatchToProps = {
  updatePlayerSetAmount: _actions.updatePlayerSetAmount,
  updateQuickDepositInitData: _actions.updateQuickDepositInitData,
  onFormSubmit: _actions.performDeposit
};

/**
 * Validates amount value using payment api utility methods
 * @param {Map} values the form values
 * @returns {Promise} validation promise
 */
var asyncValidate = function asyncValidate(values) {
  return _quickDepositLogic.PaymentsApi.asyncSetDepositAmountIfValid(values.get(_constants.QD_RF_FIELD_CARDID), (0, _quickDepositLogic.formatNumber)(values.get(_constants.QD_RF_FIELD_AMOUNT), 2));
};
var reduxFormConfig = {
  form: _constants.QD_RF_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: false,
  asyncValidate: asyncValidate,
  asyncBlurFields: [_constants.QD_RF_FIELD_AMOUNT, _constants.QD_RF_FIELD_CVV],
  onSubmit: _actions.performDeposit,
  shouldError: function shouldError(params) {
    return params.props.anyTouched;
  },
  shouldWarn: function shouldWarn(params) {
    return params.props.anyTouched;
  },
  shouldValidate: function shouldValidate(params) {
    return params.props.anyTouched;
  }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)(reduxFormConfig)((0, _uiTranslations.withTranslator)(_FormComponent2.default)));